import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

/**
 * Slide-over right side modal drawer (matching Live Transactions inspector style)
 */
export default function ModalC({ isOpen, setOpen, children, sx, width }) {
  const { border, borderRadius, position, top, left, transform, maxHeight, ...filteredSx } = sx || {};

  return (
    <Drawer
      anchor="right"
      open={Boolean(isOpen)}
      onClose={setOpen}
      PaperProps={{
        sx: {
          width: width || { xs: '100%', sm: 540, md: 620 },
          maxWidth: '100vw',
          height: '100%',
          bgcolor: 'background.paper',
          p: { xs: 2, sm: 3 },
          overflowY: 'auto',
          boxShadow: '-8px 0 32px rgba(0, 0, 0, 0.12)',
          borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
          ...filteredSx,
        },
      }}
    >
      <Box sx={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Drawer>
  );
}

ModalC.propTypes = {
  isOpen: PropTypes.bool,
  setOpen: PropTypes.func,
  children: PropTypes.node,
  sx: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
};
